import axios from 'axios'
import { getContext } from 'svelte'

export class FormHandler {
  constructor(callback, store, snapshot, snackBarHandler, modalMsgHandler, db = getContext('db')) {
    this.callback = callback
    this._store = store
    this.snapshot = snapshot
    this.snackBar = snackBarHandler
    this.modalMsgHandler = modalMsgHandler
    this.db = db
  }
  #loader() {
    let previousData = this.snapshot.data
    previousData.loaded = false
    this._store.set(previousData)
  }
  async submit(form) {
    this.#loader()
    const formData = new FormData(form)
    const data = {}
    for (let field of formData) {
      const [key, value] = field
      switch (key) {
        case 'delete':
          break
        default:
          data[key] = value.trim()
          break
      }
    }
    if (
      !data.id && (
        data.nome.length == 0 ||
        data.instagram.length == 0 ||
        data.email.length == 0 ||
        data.celular.length == 0 ||
        data.dia_nascimento?.length == 0 ||
        data.mes_nascimento?.length == 0 ||
        data.ano_nascimento?.length == 0
      )
    ) {
      this._store.set({loaded: true})
      this.callback('Ops...', 'Você precisa preencher obrigatoriamente os campos Nome, Instagram, Email, Celular e Data de Nascimento para poder se cadastrar.', 'error')
      return
    }
    if (!data.id && data.aceito_regulamento_e_politica !== '1') {
      this._store.set({loaded: true})
      this.callback('Ops...', 'Você precisa aceitar nossa Política de Privacidade', 'error')
      return
    }
    delete data.id
    if (!data.nascimento) {
      let nascimentoStamp = Date.parse(`${data.ano_nascimento}-${data.mes_nascimento}-${data.dia_nascimento}T12:00:00.000-03:00`)
      data['nascimento'] = new Date(nascimentoStamp)
    }
    delete data.dia_nascimento
    delete data.mes_nascimento
    delete data.ano_nascimento
    data.created_date = data.created_date ? data.created_date : new Date()
    axios.post('https://qgoppzhdyb.execute-api.sa-east-1.amazonaws.com/default/bicsoleil_encontrinho', data)
      .then(res => {
        this._store.set({loaded: true})
        if (this.snackBar) {
          this.snackBar.action(res.data.msg, 6000, res.data.status)
        }
        if (res.data.status == 'success') {
          this.callback('Dados enviados com sucesso.', res.data.msg, 'success')
          if (this.modalMsgHandler) {
            setTimeout(() => {
              this.modalMsgHandler.data.success = true
            }, 200);
          }
        } else {
          this.callback('Ops...', res.data.msg, 'error')
        }
      })
      .catch(error => {
        this._store.set({loaded: true})
        if (this.snackBar) {
          this.snackBar.action(error, 6000, 'error')
        }
        this.callback('Ops... Houve um erro no envio dos dados :(', error, 'error')
      })
  }
}